import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";

import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import Collapse from "@material-ui/core/Collapse";
import Divider from "@material-ui/core/Divider";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import UnfoldLessIcon from "@material-ui/icons/UnfoldLess";
import UnfoldMoreIcon from "@material-ui/icons/UnfoldMore";
import { Badge, makeStyles } from "@material-ui/core";

import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import BusinessOutlinedIcon from "@material-ui/icons/Business";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import QuestionAnswerOutlinedIcon from "@material-ui/icons/QuestionAnswerOutlined";
import LabelOutlinedIcon from "@material-ui/icons/LabelOutlined";
import FlagOutlinedIcon from "@material-ui/icons/FlagOutlined";
import CallSplitOutlinedIcon from "@material-ui/icons/CallSplitOutlined";
import EventOutlinedIcon from "@material-ui/icons/EventOutlined";
import HistoryOutlinedIcon from "@material-ui/icons/HistoryOutlined";
import ViewWeekOutlinedIcon from "@material-ui/icons/ViewWeekOutlined";
import ShoppingCartOutlinedIcon from "@material-ui/icons/ShoppingCartOutlined";
import CategoryOutlinedIcon from "@material-ui/icons/CategoryOutlined";
import TimelineOutlinedIcon from "@material-ui/icons/TimelineOutlined";
import MenuBookOutlinedIcon from "@material-ui/icons/MenuBookOutlined";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import TrendingUpOutlinedIcon from "@material-ui/icons/TrendingUpOutlined";
import AutorenewOutlinedIcon from "@material-ui/icons/AutorenewOutlined";
import NotificationImportantOutlinedIcon from "@material-ui/icons/NotificationImportantOutlined";
import RepeatOutlinedIcon from "@material-ui/icons/RepeatOutlined";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";
import GavelOutlinedIcon from "@material-ui/icons/Gavel";
import EventAvailableOutlinedIcon from "@material-ui/icons/EventAvailableOutlined";
import AssessmentOutlinedIcon from "@material-ui/icons/AssessmentOutlined";
import AssignmentTurnedInOutlinedIcon from "@material-ui/icons/AssignmentTurnedInOutlined";
import SettingsEthernetIcon from "@material-ui/icons/SettingsEthernet";
import HighlightOffOutlinedIcon from "@material-ui/icons/HighlightOffOutlined";
import AccountBalanceWalletOutlinedIcon from "@material-ui/icons/AccountBalanceWalletOutlined";
import LocalAtmOutlinedIcon from "@material-ui/icons/LocalAtmOutlined";
import TrendingDownOutlinedIcon from "@material-ui/icons/TrendingDownOutlined";
import SwapHorizOutlinedIcon from "@material-ui/icons/SwapHorizOutlined";
import EqualizerOutlinedIcon from "@material-ui/icons/EqualizerOutlined";
import LayersOutlinedIcon from "@material-ui/icons/LayersOutlined";
import PaymentOutlinedIcon from "@material-ui/icons/PaymentOutlined";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import EmojiEventsOutlinedIcon from "@material-ui/icons/EmojiEventsOutlined";
import BarChartOutlinedIcon from "@material-ui/icons/BarChartOutlined";
import StarsOutlinedIcon from "@material-ui/icons/StarsOutlined";
import TuneOutlinedIcon from "@material-ui/icons/TuneOutlined";
import ListAltOutlinedIcon from "@material-ui/icons/ListAltOutlined";
import MergeTypeOutlinedIcon from "@material-ui/icons/MergeTypeOutlined";
import FlashOnOutlinedIcon from "@material-ui/icons/FlashOn";
import MemoryOutlinedIcon from "@material-ui/icons/MemoryOutlined";
import NotificationsActiveOutlinedIcon from "@material-ui/icons/NotificationsActiveOutlined";
import SendOutlinedIcon from "@material-ui/icons/SendOutlined";
import VpnKeyOutlinedIcon from "@material-ui/icons/VpnKeyOutlined";
import HeadsetMicOutlinedIcon from "@material-ui/icons/HeadsetMic";
import StorefrontOutlinedIcon from "@material-ui/icons/Storefront";
import AttachMoneyOutlinedIcon from "@material-ui/icons/AttachMoney";
import WorkOutlineOutlinedIcon from "@material-ui/icons/Work";
import InsertChartOutlinedIcon from "@material-ui/icons/InsertChart";
import BuildOutlinedIcon from "@material-ui/icons/Build";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PostAddOutlinedIcon from "@material-ui/icons/PostAddOutlined";
import MailOutlineIcon from "@material-ui/icons/MailOutline";

import { i18n } from "../translate/i18n";
import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../context/Auth/AuthContext";
import { Can } from "../components/Can";

const useStyles = makeStyles((theme) => ({
	searchBox: {
		display: "flex",
		alignItems: "center",
		margin: theme.spacing(1, 1, 0.5, 1),
		padding: theme.spacing(0.25, 0.75),
		borderRadius: 6,
		backgroundColor: theme.palette.action.hover,
	},
	searchInput: {
		flex: 1,
		fontSize: 13,
		marginLeft: theme.spacing(0.75),
	},
	toolbar: {
		display: "flex",
		justifyContent: "flex-end",
		padding: theme.spacing(0, 1),
	},
	groupHeader: {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(1),
		userSelect: "none",
	},
	groupHeaderIcon: {
		minWidth: 36,
		color: "inherit",
	},
	groupTitle: {
		flex: 1,
		fontSize: 12,
		fontWeight: 600,
		letterSpacing: 0.4,
		textTransform: "uppercase",
		color: "inherit",
	},
	nestedItem: {
		paddingLeft: theme.spacing(3),
	},
	hidden: {
		display: "none",
	},
}));

const SidebarFilterContext = React.createContext({ filter: "", matches: () => true, collapsed: false });

function ListItemLink({ icon, primary, to, className, active }) {
	const { matches, collapsed } = React.useContext(SidebarFilterContext);
	const renderLink = React.useMemo(
		() =>
			React.forwardRef((itemProps, ref) => (
				<RouterLink to={to} ref={ref} {...itemProps} />
			)),
		[to]
	);

	if (!matches(primary)) return null;

	const item = (
		<ListItem
			button
			component={renderLink}
			className={collapsed ? undefined : className}
			selected={!!active}
			aria-current={active ? "page" : undefined}
			style={collapsed ? { justifyContent: "center", paddingLeft: 0, paddingRight: 0 } : undefined}
		>
			{icon ? (
				<ListItemIcon style={collapsed ? { minWidth: 0, justifyContent: "center" } : undefined}>
					{icon}
				</ListItemIcon>
			) : null}
			{!collapsed && <ListItemText primary={primary} />}
		</ListItem>
	);

	return (
		<li>
			{collapsed ? (
				<Tooltip title={primary} placement="right">
					{item}
				</Tooltip>
			) : (
				item
			)}
		</li>
	);
}

function SidebarGroup({ id, title, icon, defaultOpen, children, classes }) {
	const storageKey = `sidebar.group.${id}`;
	const { filter, collapsed } = React.useContext(SidebarFilterContext);
	const readPersisted = React.useCallback(() => {
		try {
			const saved = localStorage.getItem(storageKey);
			if (saved === null) return !!defaultOpen;
			return saved === "1";
		} catch (e) {
			return !!defaultOpen;
		}
	}, [storageKey, defaultOpen]);
	const [open, setOpen] = useState(readPersisted);

	useEffect(() => {
		const handler = () => setOpen(readPersisted());
		window.addEventListener("sidebar:groups-changed", handler);
		return () => window.removeEventListener("sidebar:groups-changed", handler);
	}, [readPersisted]);

	const toggle = (e) => {
		e.stopPropagation();
		setOpen((v) => {
			const next = !v;
			try {
				localStorage.setItem(storageKey, next ? "1" : "0");
			} catch (err) {
				/* ignore */
			}
			return next;
		});
	};

	// Force-open when filtering, but don't persist override
	const forceOpen = filter && filter.length > 0;
	const expanded = forceOpen || open;
	const panelId = `sidebar-group-${id}`;

	// Quando recolhida, omite cabeçalho do grupo e renderiza os filhos
	// direto (cada ListItemLink já lida com tooltip + só ícone).
	if (collapsed) {
		return <div role="group">{children}</div>;
	}

	return (
		<>
			<ListItem
				button
				dense
				onClick={toggle}
				className={classes.groupHeader}
				aria-expanded={expanded}
				aria-controls={panelId}
			>
				{icon ? (
					<ListItemIcon className={classes.groupHeaderIcon}>{icon}</ListItemIcon>
				) : null}
				<span className={classes.groupTitle}>{title}</span>
				{expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
			</ListItem>
			<Collapse in={expanded} timeout="auto" unmountOnExit id={panelId}>
				<div role="group">{children}</div>
			</Collapse>
		</>
	);
}

const MainListItems = (props) => {
	const { drawerClose, collapsed = false } = props;
	const { whatsApps } = useContext(WhatsAppsContext);
	const { user } = useContext(AuthContext);
	const [connectionWarning, setConnectionWarning] = useState(false);
	const [filter, setFilter] = useState("");
	const classes = useStyles();
	const location = useLocation();
	const path = location.pathname;

	const normalize = (s) =>
		(s || "")
			.toString()
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "")
			.toLowerCase();
	const filterCtxValue = useMemo(() => {
		const q = normalize(filter).trim();
		return {
			filter: q,
			matches: (text) => !q || normalize(text).includes(q),
			collapsed,
		};
	}, [filter, collapsed]);

	const expandAll = (open) => {
		const ids = [
			"atendimento",
			"comercial",
			"catalogo",
			"financeiro",
			"projetos",
			"performance",
			"automacao",
			"administracao",
		];
		try {
			ids.forEach((id) =>
				localStorage.setItem(`sidebar.group.${id}`, open ? "1" : "0")
			);
		} catch (e) {
			/* ignore */
		}
		window.dispatchEvent(new CustomEvent("sidebar:groups-changed"));
	};

	useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			if (whatsApps.length > 0) {
				const offlineWhats = whatsApps.filter((whats) => {
					return (
						whats.status === "qrcode" ||
						whats.status === "PAIRING" ||
						whats.status === "DISCONNECTED" ||
						whats.status === "TIMEOUT" ||
						whats.status === "OPENING"
					);
				});
				setConnectionWarning(offlineWhats.length > 0);
			}
		}, 2000);
		return () => clearTimeout(delayDebounceFn);
	}, [whatsApps]);

	const isActive = useMemo(
		() => (to) => {
			if (to === "/") return path === "/";
			return path === to || path.startsWith(`${to}/`);
		},
		[path]
	);

	const itemProps = (to) => ({
		to,
		className: classes.nestedItem,
		active: isActive(to),
	});

	return (
		<SidebarFilterContext.Provider value={filterCtxValue}>
		<div onClick={drawerClose} role="navigation" aria-label="Menu principal">
			{!collapsed && (
				<>
					<div
						className={classes.searchBox}
						onClick={(e) => e.stopPropagation()}
					>
						<SearchIcon fontSize="small" color="action" />
						<InputBase
							placeholder="Filtrar menu..."
							value={filter}
							onChange={(e) => setFilter(e.target.value)}
							className={classes.searchInput}
							inputProps={{ "aria-label": "Filtrar itens do menu" }}
						/>
						{filter ? (
							<IconButton
								size="small"
								onClick={() => setFilter("")}
								aria-label="Limpar filtro"
							>
								<ClearIcon fontSize="small" />
							</IconButton>
						) : null}
					</div>
					<div
						className={classes.toolbar}
						onClick={(e) => e.stopPropagation()}
					>
						<Tooltip title="Expandir todos">
							<IconButton
								size="small"
								onClick={() => expandAll(true)}
								aria-label="Expandir todos os grupos"
							>
								<UnfoldMoreIcon fontSize="small" />
							</IconButton>
						</Tooltip>
						<Tooltip title="Recolher todos">
							<IconButton
								size="small"
								onClick={() => expandAll(false)}
								aria-label="Recolher todos os grupos"
							>
								<UnfoldLessIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</div>
				</>
			)}
			<ListItemLink
				to="/"
				primary="Dashboard"
				icon={<DashboardOutlinedIcon />}
				active={isActive("/")}
			/>

			<SidebarGroup
				id="atendimento"
				title="Atendimento"
				icon={<HeadsetMicOutlinedIcon fontSize="small" />}
				defaultOpen
				classes={classes}
			>
				<ListItemLink
					primary={i18n.t("mainDrawer.listItems.tickets")}
					icon={<WhatsAppIcon />}
					{...itemProps("/tickets")}
				/>
				<ListItemLink
					primary={i18n.t("mainDrawer.listItems.contacts")}
					icon={<ContactPhoneOutlinedIcon />}
					{...itemProps("/contacts")}
				/>
				<ListItemLink
					primary="Agenda"
					icon={<EventOutlinedIcon />}
					{...itemProps("/agenda")}
				/>
			</SidebarGroup>

			<SidebarGroup
				id="comercial"
				title="Comercial / CRM"
				icon={<BusinessOutlinedIcon fontSize="small" />}
				defaultOpen
				classes={classes}
			>
				<ListItemLink
					primary="Clientes"
					icon={<BusinessOutlinedIcon />}
					{...itemProps("/clients")}
				/>
				<ListItemLink
					primary="Duplicados"
					icon={<MergeTypeOutlinedIcon />}
					{...itemProps("/client-duplicates")}
				/>
				<ListItemLink
					primary="Pipeline (Kanban)"
					icon={<ViewWeekOutlinedIcon />}
					{...itemProps("/deals")}
				/>
				<ListItemLink
					primary="Datas a trabalhar"
					icon={<EventAvailableOutlinedIcon />}
					{...itemProps("/key-dates")}
				/>
				<ListItemLink
					primary="Precisam de Atenção"
					icon={<NotificationImportantOutlinedIcon />}
					{...itemProps("/deal-attention")}
				/>
				<ListItemLink
					primary="Propostas"
					icon={<DescriptionOutlinedIcon />}
					{...itemProps("/proposals")}
				/>
				<ListItemLink
					primary="Pedidos"
					icon={<ReceiptOutlinedIcon />}
					{...itemProps("/orders")}
				/>
				<ListItemLink
					primary="Contratos"
					icon={<AssignmentTurnedInOutlinedIcon />}
					{...itemProps("/contracts")}
				/>
				<ListItemLink
					primary="Aprovações"
					icon={<GavelOutlinedIcon />}
					{...itemProps("/approvals")}
				/>
				<ListItemLink
					primary="Cadências"
					icon={<RepeatOutlinedIcon />}
					{...itemProps("/cadences")}
				/>
				<ListItemLink
					primary="Análise Comercial"
					icon={<InsertChartOutlinedIcon />}
					{...itemProps("/analytics/sales")}
				/>
				<ListItemLink
					primary="Origem e Resultado"
					icon={<AssessmentOutlinedIcon />}
					{...itemProps("/analytics/tag-funnel")}
				/>
				<ListItemLink
					primary="Previsão de Vendas"
					icon={<TrendingUpOutlinedIcon />}
					{...itemProps("/forecast")}
				/>
				<ListItemLink
					primary="Assinaturas"
					icon={<AutorenewOutlinedIcon />}
					{...itemProps("/subscriptions")}
				/>
				<Can
					role={user.profile}
					perform="drawer-admin-items:view"
					yes={() => (
						<ListItemLink
							primary="Score de Clientes"
							icon={<StarsOutlinedIcon />}
							{...itemProps("/scores/clients")}
						/>
					)}
				/>
			</SidebarGroup>

			<Can
				role={user.profile}
				perform="drawer-admin-items:view"
				yes={() => (
					<>
						<SidebarGroup
							id="catalogo"
							title="Catálogo"
							icon={<StorefrontOutlinedIcon fontSize="small" />}
							classes={classes}
						>
							<ListItemLink
								primary="Produtos"
								icon={<ShoppingCartOutlinedIcon />}
								{...itemProps("/products")}
							/>
							<ListItemLink
								primary="Categorias"
								icon={<CategoryOutlinedIcon />}
								{...itemProps("/product-categories")}
							/>
						</SidebarGroup>

						<SidebarGroup
							id="financeiro"
							title="Financeiro"
							icon={<AttachMoneyOutlinedIcon fontSize="small" />}
							classes={classes}
						>
							<ListItemLink
								primary="Dashboard Financeiro"
								icon={<EqualizerOutlinedIcon />}
								{...itemProps("/finance/dashboard")}
							/>
							<ListItemLink
								primary="Contas"
								icon={<AccountBalanceWalletOutlinedIcon />}
								{...itemProps("/finance/accounts")}
							/>
							<ListItemLink
								primary="Categorias"
								icon={<LayersOutlinedIcon />}
								{...itemProps("/finance/categories")}
							/>
							<ListItemLink
								primary="Centros de Custo"
								icon={<LocalAtmOutlinedIcon />}
								{...itemProps("/finance/cost-centers")}
							/>
							<ListItemLink
								primary="Contas a Pagar"
								icon={<TrendingDownOutlinedIcon />}
								{...itemProps("/finance/payables")}
							/>
							<ListItemLink
								primary="Contas a Receber"
								icon={<TrendingUpOutlinedIcon />}
								{...itemProps("/finance/receivables")}
							/>
							<ListItemLink
								primary="Movimentações"
								icon={<SwapHorizOutlinedIcon />}
								{...itemProps("/finance/transactions")}
							/>
							<ListItemLink
								primary="Gateways de Pagamento"
								icon={<PaymentOutlinedIcon />}
								{...itemProps("/payment-gateways")}
							/>
						</SidebarGroup>

						<SidebarGroup
							id="projetos"
							title="Projetos"
							icon={<WorkOutlineOutlinedIcon fontSize="small" />}
							classes={classes}
						>
							<ListItemLink
								primary="Projetos"
								icon={<AssignmentOutlinedIcon />}
								{...itemProps("/projects")}
							/>
							<ListItemLink
								primary="Tarefas"
								icon={<AssignmentOutlinedIcon />}
								{...itemProps("/tasks")}
							/>
						</SidebarGroup>

						<SidebarGroup
							id="performance"
							title="Performance"
							icon={<InsertChartOutlinedIcon fontSize="small" />}
							classes={classes}
						>
							<ListItemLink
								primary="Metas"
								icon={<EmojiEventsOutlinedIcon />}
								{...itemProps("/goals")}
							/>
							<ListItemLink
								primary="Dashboards"
								icon={<BarChartOutlinedIcon />}
								{...itemProps("/dashboards")}
							/>
							<ListItemLink
								primary="Operação"
								icon={<TimelineOutlinedIcon />}
								{...itemProps("/analytics/operations")}
							/>
							<ListItemLink
								primary="Produtividade"
								icon={<InsertChartOutlinedIcon />}
								{...itemProps("/productivity")}
							/>
						</SidebarGroup>

						<SidebarGroup
							id="automacao"
							title="Automação"
							icon={<FlashOnOutlinedIcon fontSize="small" />}
							classes={classes}
						>
							<ListItemLink
								primary="Campanhas"
								icon={<SendOutlinedIcon />}
								{...itemProps("/campaigns")}
							/>
							{/* Fica junto de Campanhas porque é a entrada do funil:
							    o formulário é o que a campanha divulga. */}
							<ListItemLink
								primary="Formulários"
								icon={<PostAddOutlinedIcon />}
								{...itemProps("/forms")}
							/>
							<ListItemLink
								primary="Fluxos de IA"
								icon={<MemoryOutlinedIcon />}
								{...itemProps("/ai-flows")}
							/>
							<ListItemLink
								primary="Base de Conhecimento"
								icon={<MenuBookOutlinedIcon />}
								{...itemProps("/knowledge-base")}
							/>
							<ListItemLink
								primary="Consumo de IA"
								icon={<MemoryOutlinedIcon />}
								{...itemProps("/ai-consumption")}
							/>
							<ListItemLink
								primary="Automações"
								icon={<FlashOnOutlinedIcon />}
								{...itemProps("/automations")}
							/>
							<ListItemLink
								primary="Logs de Automação"
								icon={<HistoryOutlinedIcon />}
								{...itemProps("/automations/logs")}
							/>
							<ListItemLink
								primary="Notificações"
								icon={<NotificationsActiveOutlinedIcon />}
								{...itemProps("/notifications")}
							/>
						</SidebarGroup>

						<Divider />

						<SidebarGroup
							id="administracao"
							title={i18n.t("mainDrawer.listItems.administration")}
							icon={<BuildOutlinedIcon fontSize="small" />}
							classes={classes}
						>
							<ListItemLink
								primary={i18n.t("mainDrawer.listItems.users")}
								icon={<PeopleAltOutlinedIcon />}
								{...itemProps("/users")}
							/>
							<ListItemLink
								primary="Departamentos"
								icon={<BusinessOutlinedIcon />}
								{...itemProps("/departments")}
							/>
							<ListItemLink
								primary={i18n.t("mainDrawer.listItems.queues")}
								icon={<AccountTreeOutlinedIcon />}
								{...itemProps("/queues")}
							/>
							<ListItemLink
								primary={i18n.t("mainDrawer.listItems.connections")}
								icon={
									<Badge
										badgeContent={connectionWarning ? "!" : 0}
										color="error"
										overlap="rectangular"
									>
										<SyncAltIcon />
									</Badge>
								}
								{...itemProps("/connections")}
							/>
							<ListItemLink
								primary={i18n.t("mainDrawer.listItems.quickAnswers")}
								icon={<QuestionAnswerOutlinedIcon />}
								{...itemProps("/quickAnswers")}
							/>
							{!collapsed && (
								<ListSubheader inset disableSticky>
									Cadastros auxiliares
								</ListSubheader>
							)}
							<ListItemLink
								primary="Status de Cliente"
								icon={<FlagOutlinedIcon />}
								{...itemProps("/client-statuses")}
							/>
							<ListItemLink
								primary="Origens de Cliente"
								icon={<CallSplitOutlinedIcon />}
								{...itemProps("/client-sources")}
							/>
							<ListItemLink
								primary="Tags de Cliente"
								icon={<LabelOutlinedIcon />}
								{...itemProps("/client-tags")}
							/>
							<ListItemLink
								primary="Campos Personalizados"
								icon={<ListAltOutlinedIcon />}
								{...itemProps("/client-field-definitions")}
							/>
							<ListItemLink
								primary="Contas de E-mail"
								icon={<MailOutlineIcon />}
								{...itemProps("/email-accounts")}
							/>
							<ListItemLink
								primary="Pipelines"
								icon={<TimelineOutlinedIcon />}
								{...itemProps("/pipelines")}
							/>
							<ListItemLink
								primary="Motivos de Perda"
								icon={<HighlightOffOutlinedIcon />}
								{...itemProps("/lost-reasons")}
							/>
							<ListItemLink
								primary="Regras de Score"
								icon={<TuneOutlinedIcon />}
								{...itemProps("/scores/rules")}
							/>
							{!collapsed && (
								<ListSubheader inset disableSticky>
									Sistema
								</ListSubheader>
							)}
							<ListItemLink
								primary="Auditoria"
								icon={<HistoryOutlinedIcon />}
								{...itemProps("/audit-logs")}
							/>
							<ListItemLink
								primary="Tokens de API"
								icon={<VpnKeyOutlinedIcon />}
								{...itemProps("/api-tokens")}
							/>
							<ListItemLink
								primary="Webhooks de Saída"
								icon={<SettingsEthernetIcon />}
								{...itemProps("/outbound-webhooks")}
							/>
							<ListItemLink
								primary={i18n.t("mainDrawer.listItems.settings")}
								icon={<SettingsOutlinedIcon />}
								{...itemProps("/settings")}
							/>
						</SidebarGroup>
					</>
				)}
			/>
		</div>
		</SidebarFilterContext.Provider>
	);
};

export default MainListItems;
